import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../../../constants/rentalPortal'
import {
  getIsListingClosed,
  getIsListingPublished,
  getListingStatusBadge,
  getListingTransition,
} from '../../../../RentalPortalListing'

import {
  LISTING_STATUS_TRANSITION_KEY,
  LISTING_STATUS_TRANSITION_REASON_TOOLTIP_KEY,
  LISTING_STATUS_TRANSITION_TARGETS,
} from './RentalPortalListingProfileHeaderStatusSelect.constants'

function getListingStatusOptionBlockReason({ listing, status, t }) {
  const transition = getListingTransition({
    key: LISTING_STATUS_TRANSITION_KEY[status],
    listing,
  })

  return transition?.permitted
    ? null
    : t(
        LISTING_STATUS_TRANSITION_REASON_TOOLTIP_KEY[transition?.reason] ??
          'RentalPortal.ListingStatusChangeNotAllowedTooltipKey'
      )
}

function getListingStatusOption({ status, t }) {
  return {
    label: t(RENTAL_PORTAL_LISTING_STATUSES[status].text),
    textColor: RENTAL_PORTAL_LISTING_STATUSES[status].textColor,
    value: status,
  }
}

export function getIsListingStatusReadOnly({ isPreview, options, status }) {
  return isPreview || getIsListingClosed(status) || options.length === 0
}

export function getListingStatusSelectValue({ listing, t }) {
  return RENTAL_PORTAL_LISTING_STATUSES[listing?.status]
    ? {
        ...getListingStatusOption({ status: listing.status, t }),
        ...getListingStatusBadge({ listing, t }),
      }
    : null
}

export function getListingStatusSelectOptions({ listing, t }) {
  return LISTING_STATUS_TRANSITION_TARGETS.filter(
    status => status !== listing?.status
  ).map(status => {
    const blockReason = getListingStatusOptionBlockReason({
      listing,
      status,
      t,
    })

    return {
      ...getListingStatusOption({ status, t }),
      disabled: Boolean(blockReason),
      tooltipContent: blockReason,
    }
  })
}

export function getListingStatusChangeDescription({
  livePortalNames,
  name,
  status,
  t,
}) {
  return getIsListingPublished(status)
    ? t('RentalPortal.ListingActivateConfirmationTextKey', { name })
    : [
        t('RentalPortal.ListingDeactivateConfirmationTextKey', { name }),
        livePortalNames.length > 0
          ? t('RentalPortal.ListingStatusDeactivateLivePortalsRemovedKey', {
              portals: livePortalNames.join(', '),
            })
          : null,
      ]
        .filter(Boolean)
        .join(CHARACTER_WHITESPACE)
}
